import { createAsyncThunk } from '@reduxjs/toolkit';
import { followUpAPI } from '../follow-up/followUpAPI';

const fetchByOrigemAsync = createAsyncThunk(
  'followUpDestinoBaixa/fetchByOrigem',
  async (origemFollowupId, { rejectWithValue }) => {
    try {
      const { data } = await followUpAPI.fetchFollowupsDestinoBaixa([
        { name: 'origemFollowupId', value: origemFollowupId },
      ]);
      return { data };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message || 'Erro ao carregar followups de destino.');
    }
  }
);

const followUpDestinoBaixaThunks = { fetchByOrigemAsync };
export default followUpDestinoBaixaThunks;
